import clientAuth from "../clientAuth";
import client from "../client";

export default {
  login: (userData) => client.post('session/login', { json: userData }),
  userlogout: (userData) => clientAuth.post('session/logout', { json: userData }),
  forgot_pwd: (userData) => client.post('session/forgot-password', { json: userData }),
  profileupdate: (userData) => clientAuth.post('session/admin/updateprofile', { json: userData }),
  GetUser: () => clientAuth.get('session/admin/show'),
  UserchangePassword: (userData) => clientAuth.post('session/admin/change-password', { json: userData }),

  // Get User list
  GetUserList: (page = 1,userData) => clientAuth.post(`admin/users/index?page=${page}`, { json: userData }),
  ChangeUserStatus: (userId) => clientAuth.post(`admin/users/active/deactive/${userId}`),
  DeleteUser: (userId) => clientAuth.delete(`admin/users/destroy/${userId}`),
  AddUser: (userData) => clientAuth.post('admin/users/store', { json: userData }),
  GetUserById: (userId) => clientAuth.get(`admin/users/show/${userId}`),
  UpdateUser: (userId, formData) => clientAuth.post(`admin/users/update/${userId}`, { json: formData }),

  AssigneDrugIdUser: (userId, userData) => clientAuth.post(`admin/users/assigne/drug/${userId}`, { json: userData }),
  AssignedDrugIdlist: (userId) => clientAuth.get(`admin/users/assigned/drug/list/${userId}`),

  // User register 
  NewUserRegister: (userData) => client.post('session/user/register', { json: userData }),

  // session/user/drug/list 
  GetUserAssignedDrugList: () => clientAuth.get('session/user/drug/list'),

  // session/user/show/drug/form  
  ShowUserdrugDetailForm: (drugId) => clientAuth.get(`session/user/show/drug/form/${drugId}`),

  // search user 18-03-25
  searchUsers: (userData) => clientAuth.post('admin/users/search', { json: userData }),

  // total Inactive Users
  totalInactiveusers: () => clientAuth.get(`admin/count/total/inactive/users`),
  
  // total/assigned/drug
  totalAssignedDrugs: () => clientAuth.get(`session/total/assigned/drug`),

  // notification
  AllNotificationList: () => clientAuth.get(`notification/notification-list`),

  // notification/unread-notification-count
  NotificationUnreadCount: () => clientAuth.get(`notification/unread-notification-count`),

  // mark-all-read
  NotificationMarkallread: () => clientAuth.get(`notification/mark-all-read`),
};